(function () {
  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function initMenu() {
    const menu = qs(".js-ec-menu");
    const open = qs(".js-ec-menu-open");
    const close = qs(".js-ec-menu-close");
    if (!menu || !open || !close) return;
    open.addEventListener("click", () => {
      menu.classList.add("is-open");
      menu.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    });
    close.addEventListener("click", () => {
      menu.classList.remove("is-open");
      menu.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    });
  }

  function initCart() {
    qsa(".js-ec-cart-open").forEach((button) => {
      button.addEventListener("click", () => {
        const drawer = qs("cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          drawer.open(button);
          return;
        }
        window.location.href = window.routes?.cart_url || "/cart";
      });
    });
  }

  function initNewsletterLink() {
    qsa(".js-ec-newsletter-link").forEach((button) => {
      button.addEventListener("click", () => {
        const menu = qs(".js-ec-menu");
        menu?.classList.remove("is-open");
        menu?.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        openNewsletterModal({ remember: false });
      });
    });
  }

  function openNewsletterModal({ remember = true } = {}) {
    const modal = qs(".js-ec-newsletter-modal");
    if (!modal) return;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    modal.dataset.rememberClose = remember ? "true" : "false";
    document.body.style.overflow = "hidden";
    window.setTimeout(() => qs("#EuphoriaNewsletterEmail")?.focus({ preventScroll: true }), 160);
  }

  function closeNewsletterModal() {
    const modal = qs(".js-ec-newsletter-modal");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (modal.dataset.rememberClose !== "false") {
      try {
        window.localStorage.setItem("ecNewsletterDismissed", "true");
      } catch (error) {
        // localStorage can be unavailable in private browser modes.
      }
    }
    document.body.style.overflow = "";
  }

  function initNewsletterPopup() {
    const modal = qs(".js-ec-newsletter-modal");
    if (!modal) return;

    qsa(".js-ec-newsletter-close", modal).forEach((button) => {
      button.addEventListener("click", closeNewsletterModal);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("is-open")) closeNewsletterModal();
    });

    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem("ecNewsletterDismissed") === "true";
    } catch (error) {
      dismissed = false;
    }
    if (!dismissed) {
      window.setTimeout(() => openNewsletterModal(), 900);
    }
  }

  function initSpace() {
    const root = qs(".js-ec-space");
    if (!root) return;

    const grid = qs(".js-ec-grid", root);
    const panels = qsa(".js-ec-panel", root).map((el) => ({
      el,
      z: Number(el.dataset.z || "-600"),
    }));
    if (!panels.length) return;

    const cursor = qs(".js-ec-cursor", root);
    const cursorTitle = cursor ? qs(".js-ec-cursor-title", cursor) : null;
    let velocity = window.innerWidth < 768 ? 1.45 : 2.15;
    const baseVelocity = velocity;
    const threshold = window.innerWidth < 768 ? 280 : 320;
    const zStep = 220;
    const loopSlots = Math.max(panels.length, 12);
    const loopSpan = loopSlots * zStep;
    const lowerThreshold = threshold - loopSpan;
    let paused = false;
    let gridTimer = null;

    function opacityFor(z) {
      const start = window.innerWidth < 768 ? -400 : -1200;
      const end = window.innerWidth < 768 ? 120 : -560;
      const exitStart = threshold - (window.innerWidth < 768 ? 360 : 480);
      if (z <= start) return 0;
      if (z >= exitStart) return Math.max(0, (threshold - z) / (threshold - exitStart));
      if (z >= end) return 1;
      return (z - start) / (end - start);
    }

    function tick() {
      if (!paused && root.dataset.view !== "grid") {
        panels.forEach((panel) => {
          panel.z += velocity;
          while (panel.z > threshold) panel.z -= loopSpan;
          while (panel.z < lowerThreshold) panel.z += loopSpan;
          panel.el.style.transform = `translate3d(-50%, -50%, ${panel.z}px)`;
          panel.el.style.opacity = String(opacityFor(panel.z));
        });
        const diff = velocity - baseVelocity;
        velocity = Math.abs(diff) > 0.05 ? velocity - diff * 0.06 : baseVelocity;
      }
      requestAnimationFrame(tick);
    }

    root.addEventListener(
      "wheel",
      (event) => {
        if (root.dataset.view === "grid") return;
        event.preventDefault();
        velocity += event.deltaY * 0.044;
        velocity = Math.max(-16, Math.min(42, velocity));
      },
      { passive: false },
    );

    let lastY = 0;
    root.addEventListener("touchstart", (event) => {
      lastY = event.touches[0]?.clientY || 0;
    }, { passive: true });
    root.addEventListener("touchmove", (event) => {
      if (root.dataset.view === "grid") return;
      const y = event.touches[0]?.clientY || lastY;
      velocity += (lastY - y) * 0.075;
      velocity = Math.max(-16, Math.min(42, velocity));
      lastY = y;
    }, { passive: true });

    qsa(".js-ec-view", root).forEach((button) => {
      button.addEventListener("click", () => {
        const view = button.dataset.view || "space";
        root.dataset.view = view;
        qsa(".js-ec-view", root).forEach((other) => {
          other.classList.toggle("is-active", other === button);
        });
        paused = view === "grid";
        cursor?.classList.remove("is-visible");
        if (gridTimer) window.clearTimeout(gridTimer);
        if (view === "grid") {
          gridTimer = window.setTimeout(() => {
            grid?.classList.add("is-active");
          }, 80);
        } else {
          grid?.classList.remove("is-active");
        }
      });
    });

    qsa(".js-ec-product-link", root).forEach((link) => {
      link.addEventListener("mouseenter", () => {
        if (!cursor) return;
        if (root.dataset.view !== "grid") paused = true;
        if (cursorTitle) cursorTitle.textContent = link.dataset.title || "";
        cursor.classList.add("is-visible");
      });
      link.addEventListener("mouseleave", () => {
        if (root.dataset.view !== "grid") paused = false;
        cursor?.classList.remove("is-visible");
      });
    });

    root.addEventListener("mousemove", (event) => {
      if (!cursor) return;
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
      cursor.classList.toggle("is-right", event.clientX > window.innerWidth / 2);
    });

    tick();
  }

  function initProductTransitions() {
    qsa(".js-ec-product-link").forEach((link) => {
      link.addEventListener("click", (event) => {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        qs(".js-ec-cursor")?.classList.remove("is-visible");
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      });
    });
  }

  function initPdp() {
    const root = qs(".js-ec-pdp");
    if (!root) return;
    const hero = qs(".js-ec-pdp-hero", root);
    const variantInput = qs('input[name="id"]', root);
    const addLabel = qs(".js-ec-add-label", root);
    const submitButton = qs('[type="submit"][name="add"]', root);
    const priceLabel = qs(".js-ec-price", root);

    qsa(".js-ec-thumb", root).forEach((button) => {
      button.addEventListener("click", () => {
        if (!hero) return;
        hero.src = button.dataset.src || hero.src;
        qsa(".js-ec-thumb", root).forEach((other) => other.classList.toggle("is-active", other === button));
      });
    });

    qsa(".js-ec-variant", root).forEach((button) => {
      button.addEventListener("click", () => {
        qsa(".js-ec-variant", root).forEach((other) => other.classList.toggle("is-active", other === button));
        const available = button.dataset.available !== "false";
        if (variantInput) {
          variantInput.value = button.dataset.variantId || variantInput.value;
          variantInput.disabled = !available;
        }
        if (priceLabel && button.dataset.price) priceLabel.textContent = button.dataset.price;
        if (addLabel && button.dataset.price) {
          addLabel.textContent = available ? `Add to Cart — ${button.dataset.price}` : window.variantStrings?.soldOut || "Sold out";
        }
        if (hero && button.dataset.imageSrc && hero.src !== button.dataset.imageSrc) {
          hero.style.opacity = "0";
          window.setTimeout(() => {
            hero.src = button.dataset.imageSrc;
            if (button.dataset.imageAlt) hero.alt = button.dataset.imageAlt;
            if (button.dataset.imageWidth) hero.width = Number(button.dataset.imageWidth);
            if (button.dataset.imageHeight) hero.height = Number(button.dataset.imageHeight);
            hero.style.opacity = "";
          }, 160);
        }
        if (submitButton) {
          submitButton.disabled = !available;
          submitButton.toggleAttribute("aria-disabled", !available);
        }
      });
    });

  }

  document.addEventListener("DOMContentLoaded", () => {
    initMenu();
    initCart();
    initNewsletterLink();
    initNewsletterPopup();
    initSpace();
    initProductTransitions();
    initPdp();
  });
})();
